/**
 * Created by Administrator on 2017/10/26.
 */
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { Login } from "../login/login.component";
import { Banner } from "../banner/Banner.components";
import { LeadingPicture } from "../banner/leadingPicture.components";
import { SettingCourseEdit } from "../activity/settingCourseEdit.component";
import { SettingCourse } from "../activity/settingCourse.component";
import { SettingActivityEdit } from "../activity/settingActivityEdit.component";
import { SettingActivity } from "../activity/settingActivity.component";

import { MemberTaskEdit } from "../task/memberTaskEdit.component";
import { MemberTask } from "../task/memberTask.component";
import { DigitalSecretaryEdit } from "../task/digitalSecretaryEdit.component";
import { DigitalSecretary } from "../task/digitalSecretary.component";

import { ChallengeMissionEdit } from "../task/challengeMissionEdit.component";
import { ChallengeMission } from "../task/challengeMission.component";
import { FiveGoalTaskEdit } from "../task/fiveGoalTaskEdit.component";
import { FiveGoalTask } from "../task/fiveGoalTask.component";

import { Index } from "../index/Index.component";
import { EditBanner } from "../banner/BannerEdit.componen";
import { NewsCategory } from "../news/Category.component";
import { EditNewsCategory } from "../news/editCategory.component";
import { News } from "../news/news.component";
import { EditNews } from "../news/editNews.component";
import { AboutUsCategory } from "../aboutUs/Category.component";
import { EditAboutUs } from "../aboutUs/EditAboutUs.componment";
import { EditAboutUsCategory } from "../aboutUs/EditCategroy.component";
import { AboutUs } from "../aboutUs/AboutUs.component";
import { Account } from "../account/Account.componen";
import { EditAccount } from "../account/EditAccount.component";
import { ProductBanner } from "../productBanner/banner.component";
import { EditProductBanner } from "../productBanner/ProductBannerEdit.component";
import { SettingContent } from "../settingContent/SettingContent.component";
import { EditSettingContent } from "../settingContent/EditSettingContent.component";
import { ProductGenre } from "../product/ProductGenre.componment";
import { EditProductGenre } from "../product/EditProductGenre.componment";
import { Product } from "../product/Product.component";
import { EditProduct } from "../product/EditProduct.componment";
import { ProductRecommend } from "../product/RecommodProduct.componment";
/*import {ShareContent} from "../shareContent/ShareContent.component";
import {EditShare} from "../shareContent/EditShare.component";*/
import { Share } from "../share/share.component";
import { ShareEdit } from "../share/shareEdit.component";
import { Notice } from "../notice/notice.component";
import { NoticeEdit } from "../notice/noticeEdit.component";
import { SystemSetting } from "../systemSetting/systemSetting.component";
import { SystemSettingEdit } from "../systemSetting/systemSettingEdit.component";
import { Version } from "../systemSetting/version.component";
import { VersionEdit } from "../systemSetting/versionEdit.component";
import { TrackingNumber } from "../trackingNumber/trackingNumber.component";
import { TrackingNumberEdit } from "../trackingNumber/trackingNumberEdit.component";
import { Address } from "../address/address.component";
import { AddressEdit } from "../address/addressEdit.component";
import { SignInTask } from "../badge/signInTask.component";
import { SignInTaskEdit } from "../badge/signInTaskEdit.component";
import { SignInTaskProduct } from "../badge/signInTaskProduct.component";
import { SignInTaskProductEdit } from "../badge/signInTaskProductEdit.component";
import { ChallengeTask } from "../badge/challengeTask.component";
import { ChallengeTaskEdit } from "../badge/challengeTaskEdit.component";
import { SignInHistory } from "../badge/signInHistory.component";
import { SignInHistoryEdit } from "../badge/signInHistoryEdit.component";
import { BadgeGit } from "../gift/badgeGit.component";
import { BadgeGitEdit } from "../gift/badgeGitEdit.component";
import { MemberGit } from "../gift/memberGit.component";
import { MemberGitEdit } from "../gift/memberGitEdit.component";
import { MemberNotify } from "../notify/memberNotify.component";
import { MemberNotifyEdit } from "../notify/memberNotifyEdit.component";
import { Sychronous } from "../notify/sychronous.component";
import { Message } from "../message/message.component";
import { MessageEdit } from "../message/messageEdit.component";
import { InformMessage } from "../message/informMessage.component";
import { InformMessageEdit } from "../message/informMessageEdit.component";
import { Film } from "../film/film.component";
import { FilmEdit } from "../film/filmEdit.component";
import { Fanstv } from "../film/fanstv.component";
import { FanstvEdit } from "../film/fanstvEdit.component";
import { FanstvPlan } from "../film/fanstvPlan.component";
import { FanstvPlanEdit } from "../film/fanstvPlanEdit.component";
import { FilmType } from "../film/filmType.component";
import { FilmTypeEdit } from "../film/filmTypeEdit.component";
import { Supplement } from "../supplement/supplement.component";
import { SupplementEdit } from "../supplement/supplementEdit.component";
import { ExperienceTaskComponent } from "../experience-task/experience-task.component";
import { ExperienceTaskEditComponent } from "../experience-task-edit/experience-task-edit.component";
import { AppManagerComponent } from "../app-manager/app-manager.component";
import { AppManagerEditComponent } from "../app-manager-edit/app-manager-edit.component";
import { EnrollRecordListComponent } from "../enroll-record-list/enroll-record-list.component";
import { EnrollRecordDetailComponent } from "../enroll-record-detail/enroll-record-detail.component";
import { GoalListComponent } from "../goal-list/goal-list.component";
import { GoalEditComponent } from "../goal-edit/goal-edit.component";
import { GoalTaskListComponent } from "../goal-task-list/goal-task-list.component";
import { GoalTaskEditComponent } from "../goal-task-edit/goal-task-edit.component";
import { LatestActivityListComponent } from "../latest-activity-list/latest-activity-list.component";
import { LatestActivityEditComponent } from "../latest-activity-edit/latest-activity-edit.component";
import { ExperienceParamsComponent } from "../experience-params/experience-params.component";
import { ExperienceParamsEditComponent } from "../experience-params-edit/experience-params-edit.component";
import { MemberDocumentComponent } from "../member-document/member-document.component";
import { GoalParamsListComponent } from "../goal-params-list/goal-params-list.component";
import { GoalParamsEditComponent } from "../goal-params-edit/goal-params-edit.component";
import { AppAccountComponent } from "../app-account/app-account.component";
import { QuestionListComponent } from "../question-list/question-list.component";
import { QuestionEditComponent } from "../question-edit/question-edit.component";
import { UseMethodListComponent } from "../use-method-list/use-method-list.component";
import { UseMethodEditComponent } from "../use-method-edit/use-method-edit.component";
import { ShareProductComponent } from "../share-product/share-product.component";
import { ShareProductEditComponent } from "../share-product-edit/share-product-edit.component";

const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  { path: "login", component: Login },
  {
    path: "index",
    component: Index,
    children: [
      { path: "banner", component: Banner },
      { path: "banner/:id", component: EditBanner },

      { path: "leadingPicture", component: LeadingPicture },

      { path: "settingCourse", component: SettingCourse },
      { path: "settingCourse/:id", component: SettingCourseEdit },

      { path: "settingActivity", component: SettingActivity },
      { path: "settingActivity/:id", component: SettingActivityEdit },

      { path: "memberTask", component: MemberTask },
      { path: "memberTask/:id", component: MemberTaskEdit },

      { path: "digitalSecretary", component: DigitalSecretary },
      { path: "digitalSecretary/:id", component: DigitalSecretaryEdit },

      { path: "challengeMission/:id", component: ChallengeMission },
      { path: "challengeMissionEdit/:taskId/:id/:type", component: ChallengeMissionEdit },
      { path: "fiveGoalTask", component: FiveGoalTask },
      { path: "fiveGoalTask/:id", component: FiveGoalTaskEdit },

      { path: "news/category", component: NewsCategory },
      { path: "news/category/:id", component: EditNewsCategory },
      { path: "news", component: News },
      { path: "news/:id", component: EditNews },
      { path: "aboutUs/category", component: AboutUsCategory },
      { path: "aboutUs/category/:id", component: EditAboutUsCategory },
      { path: "aboutUs", component: AboutUs },
      { path: "aboutUs/:id", component: EditAboutUs },
      { path: "account", component: Account },
      { path: "account/:id", component: EditAccount },
      { path: "productBanner", component: ProductBanner },
      { path: "productBanner/:id", component: EditProductBanner },
      { path: "settingContent", component: SettingContent },
      { path: "settingContent/:code", component: EditSettingContent },
      { path: "product/genre", component: ProductGenre },
      { path: "product/genre/:id", component: EditProductGenre },
      { path: "product", component: Product },
      { path: "product/:id", component: EditProduct },
      { path: "productRecommend", component: ProductRecommend },
      /* {path:'shareContent',component:ShareContent},
    {path:'shareContent/:id',component:EditShare},*/
      { path: "share", component: Share },
      { path: "share/:id", component: ShareEdit },
      { path: "notice", component: Notice },
      { path: "notice/:id", component: NoticeEdit },
      { path: "systemSetting", component: SystemSetting },
      { path: "systemSetting/:id", component: SystemSettingEdit },
      { path: "version", component: Version },
      { path: "version/:id", component: VersionEdit },
      { path: "trackingNumber", component: TrackingNumber },
      { path: "trackingNumber/:id", component: TrackingNumberEdit },
      { path: "address", component: Address },
      { path: "address/:id", component: AddressEdit },
      { path: "signInTask", component: SignInTask },
      { path: "signInTask/:id", component: SignInTaskEdit },
      { path: "signInTaskProduct", component: SignInTaskProduct },
      { path: "signInTaskProduct/:id", component: SignInTaskProductEdit },
      { path: "challengeTask", component: ChallengeTask },
      { path: "challengeTask/:type", component: ChallengeTaskEdit },
      { path: "signInHistory", component: SignInHistory },
      { path: "signInHistory/:id/:year/:month", component: SignInHistoryEdit },
      { path: "badgeGit", component: BadgeGit },
      { path: "badgeGit/:id", component: BadgeGitEdit },
      { path: "memberGit", component: MemberGit },
      { path: "memberGit/:id", component: MemberGitEdit },
      { path: "memberNotify", component: MemberNotify },
      { path: "memberNotify/:id", component: MemberNotifyEdit },
      { path: "sychronous", component: Sychronous },
      { path: "message", component: Message },
      { path: "message/:id", component: MessageEdit },
      { path: "informMessage", component: InformMessage },
      { path: "informMessage/:id", component: InformMessageEdit },
      { path: "film", component: Film },
      { path: "film/:id", component: FilmEdit },
      { path: "fanstv", component: Fanstv },
      { path: "fanstv/:id", component: FanstvEdit },
      { path: "fanstvPlan", component: FanstvPlan },
      { path: "fanstvPlan/:code", component: FanstvPlanEdit },
      { path: "filmType", component: FilmType },
      { path: "filmType/:id", component: FilmTypeEdit },
      { path: "supplement", component: Supplement },
      { path: "supplement/:id", component: SupplementEdit },
      { path: "experiencetask", component: ExperienceTaskComponent },
      { path: "experiencetask/:id", component: ExperienceTaskEditComponent },
      { path: "appmanager", component: AppManagerComponent },
      { path: "appmanager/:id", component: AppManagerEditComponent },
      { path: "enrollrecord", component: EnrollRecordListComponent },
      { path: "enrollrecord/:id", component: EnrollRecordDetailComponent },
      { path: "goal", component: GoalListComponent },
      { path: "goal/:id", component: GoalEditComponent },
      { path: "goaltask", component: GoalTaskListComponent },
      { path: "goaltask/:id", component: GoalTaskEditComponent },
      { path: "goalParameter", component: GoalParamsListComponent },
      { path: "goalParameter/:id", component: GoalParamsEditComponent },
      { path: "latestactivity", component: LatestActivityListComponent },
      { path: "latestactivity/:id", component: LatestActivityEditComponent },
      { path: "experienceparams", component: ExperienceParamsComponent },
      {
        path: "experienceparams/:id",
        component: ExperienceParamsEditComponent,
      },
      {
        path: "memberdocument",
        component: MemberDocumentComponent,
      },
      {
        path: "appaccount",
        component: AppAccountComponent,
      },
      {
        path: "question",
        component: QuestionListComponent,
      },
      {
        path: "question/:id",
        component: QuestionEditComponent,
      },
      {
        path: "usemethod",
        component: UseMethodListComponent,
      },
      {
        path: "usemethod/:id",
        component: UseMethodEditComponent,
      },
      {
        path: "shareproduct",
        component: ShareProductComponent,
      },
      {
        path: "shareproduct/:id",
        component: ShareProductEditComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/service/router.ts